import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MigrationSource } from '../migration-reusable-components/migration-source.enum';

@Injectable({
	providedIn: 'root'
})
export class LoadComponentEventService {
	observer = new Subject<MigrationSource>();
	public subscriber$ = this.observer.asObservable();

	navigateTab(migrationSource: MigrationSource): void {
		this.observer.next(migrationSource);
	}
}
